import { render, staticRenderFns } from "./RestoreDocumentsFromLocation.vue?vue&type=template&id=1277d8de&"
import script from "./RestoreDocumentsFromLocation.vue?vue&type=script&lang=js&"
export * from "./RestoreDocumentsFromLocation.vue?vue&type=script&lang=js&"
import style0 from "./RestoreDocumentsFromLocation.vue?vue&type=style&index=0&id=1277d8de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports